import reduce from 'lodash-es/reduce'
import React, { useState } from 'react'

import {
  AlertModal,
  Banner,
  Button,
  ButtonClean,
  ConfirmModal,
  Fieldset,
  Icon,
  InputUI,
} from '@fourthwall/components'
import { DiscordIcon } from '@fourthwall/icons'
import { useFormikContext } from '@fourthwall/utils/dist/formik'
import { useDiscord } from '@modules/Dashboard/pages/Apps/pages/AppsDiscord'

import type { FormValues } from '../../types'
import * as S from './styled'

export const DiscordIntegrationFields = () => {
  const [isDisconnectModalVisible, setIsDisconnectModalVisible] = useState(false)

  const { discord } = useDiscord()
  const { values } = useFormikContext<FormValues>()

  const renderInfo = () => {
    const selectedRolesIds = reduce(
      values.selectedRoles,
      (sum, roles) => {
        return [...sum, ...roles]
      },
      [] as string[],
    )

    const hasSelectedUnavailableRole = discord.roles?.some(
      (role) => role.available === false && selectedRolesIds.indexOf(role.id) > -1,
    )

    if (!hasSelectedUnavailableRole) return null

    return (
      <Fieldset.Row>
        <Banner
          appearance="warning"
          title="Selected roles are placed above the Fourthwall bot role in your Discord server. Please visit Discord and move the Fourthwall role above all the selected roles."
        />
      </Fieldset.Row>
    )
  }

  const renderButton = () => {
    if (discord.status === 'CONNECTED') {
      return (
        <S.Container>
          <Icon component={DiscordIcon} height={20} /> Connected to Discord{' '}
          <ButtonClean
            label="Disconnect"
            disabled={discord.isLoading}
            onClick={() => setIsDisconnectModalVisible(true)}
          />
        </S.Container>
      )
    }

    return (
      <Button
        label="Connect to Discord"
        type="button"
        leftIcon={<Icon component={DiscordIcon} height={14} />}
        appearance="primary"
        disabled={discord.isLoading}
        onClick={discord.handleConnect}
      />
    )
  }

  const renderDiscordModal = () => {
    if (values.mode === 'edit') {
      return (
        <AlertModal
          title="Please remove Discord perk first"
          text="Please remove the Discord perk first before removing the server connection. You can then remove the Discord integration from the Settings / Apps tab."
          size="small"
          close={() => setIsDisconnectModalVisible(false)}
          onConfirm={() => setIsDisconnectModalVisible(false)}
        />
      )
    }

    return (
      <ConfirmModal
        title="Are you sure you want to disconnect from Discord?"
        confirmLabel="Yes, disconnect"
        confirmAppearance="destructive"
        close={() => setIsDisconnectModalVisible(false)}
        onConfirm={discord.handleDisconnect}
      />
    )
  }

  return (
    <>
      <Fieldset.Row>
        <Fieldset.Item>{renderButton()}</Fieldset.Item>
      </Fieldset.Row>
      <div style={{ marginTop: -4 }}>
        <InputUI.Suggestion>
          In order to use Discord as a membership perk you’ll have to create roles in your Discord
          server settings.
        </InputUI.Suggestion>
        {renderInfo()}
      </div>
      {isDisconnectModalVisible && renderDiscordModal()}
    </>
  )
}
